import React, { useEffect, useState } from "react";
import Explore from "../components/LandingPage/Explore";
import TripDetails from "../components/TripDetails/TripDetails";
import Layout from "../components/Layout/HomeLayout";
import Testmonials from "../components/LandingPage/Testmonials";
import TalkToExpert from "../components/LandingPage/TalkToExpert";
import PromotionBanner from "../components/LandingPage/PromotionBanner";
import PopularDestination from "../components/LandingPage/PopularDestination";
import axios from "axios";
import SecretSauce from "../components/LandingPage/SecretSauce";
import Faq from "../components/Faq";
import WhyHighMountains from "../components/LandingPage/WhyHighMountains";
import HomeBlogs from "../components/LandingPage/HomeBlogs";
import Hero from "../components/LandingPage/Hero";
import SiteReviews from "../components/SiteReviews";
import TripSlider from "../components/TripDetails/TripSlider";
import Form from "../components/Contact/Form";

const LandingPage = () => {
  const defaultFilter = "Adventure";
  const [trip, setTrip] = useState(null);
  const [sliders, setSliders] = useState(null);
  const [allTrips, setAllTrips] = useState([]);
  const [filteredTrips, setFilteredTrips] = useState([]);
  const [activeFilter, setActiveFilter] = useState(defaultFilter);

  const getHomePageSliders = () => {
    axios.get(`api/homecategory/get-home-category`).then((res) => {
      setSliders(res.data?.data[0]?.top5HomeCategory);
    });
  };

  const AllTrips = async () => {
    await axios
      .get(`api/trips/get-all-trips`)
      .then((res) => {
        let currentDate = new Date().toISOString().slice(0, 10);
        const currentTrips = res.data.data?.filter((trip) => {
          return trip.dates?.some((date) => date?.date >= currentDate);
        });

        setTrip(currentTrips);
        setAllTrips(res.data.data);

        // Apply default filter on initial load
        const filtered = res.data.data.filter((trip) =>
          trip?.category?.includes(defaultFilter)
        );
        setFilteredTrips(filtered);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    AllTrips();
    getHomePageSliders();
  }, []);

  const applyFilter = (filter) => {
    setActiveFilter(filter);

    if (filter === "All") {
      setFilteredTrips(allTrips);
    } else if (filter === "New Launches") {
      setFilteredTrips(allTrips.filter((trip) => trip.highlighted === true));
    } else {
      setFilteredTrips(
        allTrips.filter((trip) => trip?.category?.includes(filter))
      );
    }
  };

  return (
    <Layout
      trip={trip}
      title="Escape the"
      subTitle="Create beautiful stories with Us.."
    >
      {/* Inject filter CSS styles */}
      <style>{`
        .filter-wrapper {
          display: flex;
          flex-direction: row;
          gap: 24px;
          padding: 40px 20px;
          width: 100%;
          box-sizing: border-box;
          align-items: stretch;
        }

        .filter-sidebar {
          background: #fff;
          border-radius: 12px;
          border: 1px solid #ddd;
          padding: 24px 20px;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
          flex-grow: 1;
          flex-shrink: 1;
          min-width: 250px;
          max-width: 400px;
          justify-content: flex-start;
          height: 100%;
        }

        .filter-header {
          font-size: 16px;
          font-weight: 600;
          margin-bottom: 20px;
          color: #333;
        }

        .filter-options {
          display: flex;
          flex-direction: column;
          gap: 14px;
        }

        .filter-option {
          display: flex;
          align-items: center;
          gap: 10px;
          font-size: 14.5px;
          cursor: pointer;
          color: #333;
        }

        .filter-option input[type="radio"] {
          width: 16px;
          height: 16px;
          accent-color: #00a86b;
          cursor: pointer;
        }
.filter-scroll {
  max-height: 380px; /* adjust as needed */
  overflow-y: auto;
  padding-right: 6px;
  scrollbar-width: thin;
  scrollbar-color: #ccc transparent;
}

.filter-scroll::-webkit-scrollbar {
  width: 6px;
}

.filter-scroll::-webkit-scrollbar-thumb {
  background-color: #ccc;
  border-radius: 3px;
}

.filter-sidebar {
  position: sticky;
  height: fit-content;
}

        @media (max-width: 768px) {
          .filter-wrapper {
            flex-direction: column;
          }

          .filter-sidebar {
            width: 100%;
            max-width: 100%;
            min-width: auto;
            margin-bottom: 20px;
          }
            
        }

 /* Default layout for larger screens */
.filter-sidebar {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #ddd;
  padding: 24px 20px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  flex-grow: 1;
  flex-shrink: 1;
  min-width: 250px;
  max-width: 400px;
  justify-content: flex-start;
  height: 100%;
  position: sticky;
}

/* Media query for mobile devices */
@media (max-width: 768px) {
  .filter-sidebar {
    padding: 12px; /* Adjust padding for mobile */
    width: auto;
    max-width: none;
    flex-grow: 0;
    flex-shrink: 1;
    position: relative; /* Not sticky on mobile */
    overflow-x: auto; /* Allow horizontal scrolling */
    white-space: nowrap; /* Prevent wrapping of filter options */
    padding-right: 20px; /* Add space to the right for the scrollbar */
  }

  /* Add some padding between the filter options and the scrollbar */
  .filter-options {
    display: flex;
    flex-direction: row; /* Display filter options in a row */
    gap: 18px; /* Add space between options */
    white-space: nowrap; /* Prevent wrapping */
    padding-right: 20px; /* Add space to the right of the filter options */
  }

  .filter-option {
    display: inline-flex; /* Align items horizontally */
    align-items: center;
    gap: 10px;
    font-size: 14px;
    cursor: pointer;
    margin-bottom:25px;
  }

  .filter-option input[type="radio"] {
    width: 18px;
    height: 18px;
    accent-color: #00a86b;
  }
}
.


      `}</style>

      <Hero />

      {/* === Filter + Trips Section === */}
      <div className="filter-wrapper">
        {/* Filter Sidebar */}
      <div className="filter-sidebar">
  <h4 className="filter-header">Select from our tours</h4>
  <div className="filter-scroll">
    <div className="filter-options">
      {[
        "Adventure",
        "ASG Special's",
        "Autumn",
        "Backpacking Trips",
        "Bike Trips",
        "Bachelors and Party",
        "Beaches and Islands",
        "Festival Diaries",
        "Igloo Stay",
        "NYE",
        "Road Trips",
        "Romantic Getaways",
        "Land Packages",
        "Safari Specials",
        "Summer Trips",
        "Winter Trips",
        "Wellness Escapes",
      ].map((filter) => (
        <label key={filter} className="filter-option">
          <input
            type="radio"
            name="filter"
            checked={activeFilter === filter}
            onChange={() => applyFilter(filter)}
          />
          <span>{filter === "All" ? "View All" : filter}</span>
        </label>
      ))}
    </div>
  </div>
</div>


        {/* Trips Section */}
        <div style={{ flexGrow: 1, minWidth: 0 }}>
          {filteredTrips.length > 0 ? (
            <TripSlider trips={filteredTrips} />
          ) : (
            <p>No trips found</p>
          )}
        </div>
      </div>

      {/* === Other Sections === */}
      {sliders
        ?.map((item, index) => {
          const data = trip?.filter((trip) => trip?.category?.includes(item));
          return (
            data?.length > 0 && (
              <div key={index} style={{ padding: "20px 0" }}>
                <TripDetails data={data} title={item} category={item} />
              </div>
            )
          );
        })
        .slice(0, 1)}

      <PromotionBanner position={"firstBannerArray"} />
      <Explore />
 {sliders
        ?.map((item, index) => {
          const data = trip?.filter((trip) => trip?.category?.includes(item));
          return (
            data?.length > 0 && (
              <div key={index} style={{ padding: "20px 0" }}>
                <TripDetails data={data} title={item} category={item} />
              </div>
            )
          );
        })
        .slice(2, 3)}
      <PromotionBanner position={"secondBannerArray"} />

      {sliders
        ?.map((item, index) => {
          const data = trip?.filter((trip) => trip?.category?.includes(item));
          return (
            data?.length > 0 && (
              <div key={index} style={{ padding: "20px 0" }}>
                <TripDetails data={data} title={item} category={item} />
              </div>
            )
          );
        })
        .slice(3, 10)}
<PromotionBanner position={"thirdBannerArray"} />
      <PopularDestination />
{/* <Form whiteBg={true} /> */}
<SiteReviews limit={6} variant="grid" showButton={true} />
     <Testmonials />
      <WhyHighMountains />
      <HomeBlogs />
      <Faq />
    </Layout>
  );
};

export default LandingPage;
